if (!customElements.get('cft-product-rail')) {
  customElements.define('cft-product-rail', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-product-track]');
      this.cards = [...this.querySelectorAll('.cft-shopping-card')];
      if (!this.track || !this.cards.length) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.previous = this.querySelector('[data-product-previous]');
      this.next = this.querySelector('[data-product-next]');
      this.counter = this.querySelector('[data-product-current]');
      this.previous?.addEventListener('click', () => this.move(-1), options);
      this.next?.addEventListener('click', () => this.move(1), options);
      this.track.addEventListener('scroll', () => this.update(), options);
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track) return;
        const targets = { ArrowLeft: -1, ArrowRight: 1 };
        if (event.key in targets) {
          event.preventDefault();
          this.move(targets[event.key]);
        } else if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          this.go(event.key === 'Home' ? 0 : this.cards.length - 1);
        }
      }, options);
      this.track.addEventListener('dragstart', event => event.preventDefault(), options);
      this.track.addEventListener('pointerdown', event => {
        this.dragged = false;
        if (event.pointerType !== 'mouse' || event.button !== 0 ||
            event.target.closest('button,input,select,form')) return;
        this.gesture = { x: event.clientX, y: event.clientY, left: this.track.scrollLeft };
      }, options);
      this.track.addEventListener('pointermove', event => {
        if (!this.gesture) return;
        const distance = event.clientX - this.gesture.x;
        if (!this.dragged && Math.abs(event.clientY - this.gesture.y) > Math.abs(distance)) return;
        if (Math.abs(distance) < 8 && !this.dragged) return;
        if (!this.dragged) this.track.setPointerCapture(event.pointerId);
        this.dragged = true;
        this.track.dataset.dragging = '';
        this.track.scrollLeft = this.gesture.left - distance;
      }, options);
      const end = () => {
        this.gesture = null;
        delete this.track.dataset.dragging;
        setTimeout(() => { this.dragged = false; }, 0);
      };
      window.addEventListener('pointerup', end, options);
      window.addEventListener('pointercancel', end, options);
      this.track.addEventListener('click', event => {
        if (!this.dragged) return;
        event.preventDefault();
        event.stopPropagation();
        this.dragged = false;
      }, { ...options, capture: true });
      this.observer = new ResizeObserver(() => this.update());
      this.observer.observe(this.track);
      this.dataset.ready = '';
      this.update();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
    }
    update() {
      const maximum = this.track.scrollWidth - this.track.clientWidth;
      const left = this.track.scrollLeft;
      const step = this.cards[0].getBoundingClientRect().width +
        parseFloat(getComputedStyle(this.track).gap);
      this.index = maximum > 2 && left >= maximum - 2 ? this.cards.length - 1 : Math.round(left / step);
      if (this.previous) this.previous.disabled = left <= 2;
      if (this.next) this.next.disabled = maximum <= 2 || left >= maximum - 2;
      const current = String(this.index + 1);
      if (this.counter && this.counter.textContent !== current) this.counter.textContent = current;
    }
    move(direction) { this.go(this.index + direction); }
    go(index) {
      const card = this.cards[Math.max(0, Math.min(index, this.cards.length - 1))];
      const left = this.track.scrollLeft + card.getBoundingClientRect().left - this.track.getBoundingClientRect().left;
      this.track.scrollTo({ left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }
  });
}
